const cn = {
  on: {
    useSafari: '请用手机浏览器打开这个连结',
    callApp: 'Call App'
  },
  order: {
    allOrders: '全部订单',
    activeOrders: '进行中的订单',
    historyOrders: '历史订单',
    realCount: '实付',
    orderDetails: '订单详情',
    created: '已创建',
    acceptedOrder: '你接单了',
    orderCompleted: '订单完成',
    Confirmorder: '是否确认接单？',
    Ordercanceled: '订单取消',
    Rejectorder: '拒绝订单',
    Rejectcancellation: '是否拒绝接单？',
    OnceConfirmorder: '接单之后，你就没法取消订单了喔。确认接单吗？',
    responseto: '你没有在10分钟内接',
    gotit: '知道了',
    automaticallycanceled: '的订单，订单取消',
    YesCancel: '确认取消',
    YesCompleted: '确认完成',
    Yes: '确认',
    cancelOrder: '取消订单',
    thinkAgain: '再想想',
    Orderconfirmed: '订单已确认',
    rejectorder: '拒绝的话订单就马上会被取消喔，真的要狠心拒绝吗？',
    Orderrejected: '订单被拒绝',
    rejectcancellation:
      'Once you reject the cancellation request, the order will be in dispute and officially arbitrated. Still reject the cancellation request?',
    Successful: '成功了！',
    Successfully: '成功了！',
    noorders: '暂无订单',
    acceptcancellation:
      'Once you accept the cancellation request, the order will be canceled immediately. Still accept the cancellation request?',
    Reject: '拒绝',
    Confirming: '待接单',
    inProgress: '进行中',
    cancellationRequest: '申诉中',
    Dispute: '申诉中',
    Confirm: '确认',
    active: '活跃订单',
    history: '历史订单',
    completed: '完成',
    acceptedorder: '陪玩师接单了',
    Writereview: '写评论',
    Tapstars: '点亮星星给陪玩师评论喔',
    Surecancelorder: '是否取消订单？',
    Surecompleteorder: '是否完成订单？',
    reachedagreement: '客诉前请好好跟陪玩师沟通喔',
    permenantlyclosed: '确认要取消订单吗？',
    completeorder: '完成订单后就没法退款了喔',
    confirmacceptorder: '确认要取消订单吗？',
    Order: '订单编号',
    canceled: '取消',
    Play: '一起玩',
    with: '和',
    Quantity: '数量',
    Subtotal: '总价',
    Discount: '优惠券扣减',
    Total: '实付',
    purchaseSkill: '购买技能',
    Note: '备注',
    CompleteOrder: '完成订单',
    Orders: '订单',
    myorder: ' 我的订单',
    Received: '陪玩订单',
    Placed: '我的订单',
    Acceptcancellation: '是否接受取消申请？'
  },
  follow: {
    FollowList: '追踪',
    Following: '追踪列表',
    Follower: '粉丝列表',
    Follow: '粉丝',
    Followers: '粉丝',
    followyourself: '不能追踪你自己喔',
    unfollow: '确定取消追踪',
    tokenLost: 'Token Lost',
    noPlayerID: 'No PlayerID',
    End: 'End',
    nofollowers: '还没有粉丝唷',
    nofollowing: '还没有追踪的陪玩师，快去首页看看唷'
  },
  player: {
    wirteReview: '写评论',
    Review: '用户评价',
    Reviews: '用户评价',
    SeeMore: '展开',
    Skills: '技能项目',
    localtime: '当地时间',
    Buy: '下单',
    gamers: '陪玩师',
    moreSkills: '更多技能项目',
    findGamers: '发现更多陪玩师',
    noratings: '还没有评论喔',
    SeeAll: '查看全部',
    Showmore: '快来丰富一下你的个人资料喔',
    suchempty: '空荡荡～',
    editprofile: '编辑个人资料',
    Followed: '已追踪',
    Unfollow: '取消追踪',
    Cancel: '取消'
  },
  skill: {
    Add: '添加技能',
    Skills: '技能项目管理',
    finishSetting: '完成设定',
    Verifying: '审核中',
    Level: '等级',
    Rating: '评分',
    ConnectionNumber: '接单数',
    SelfIntroduction: '自我介绍',
    chat: '聊天',
    Whoops: '啊啊！',
    OK: '确认',
    Withdraw: '提领',
    Noconnection: '网路连结断开了！请检查一下您的网路连结～',
    tryAgain: '再试看看喔',
    Price: '价格',
    pricePer: '每半小时',
    Earnings: '收入',
    hourserved: '技能时长',
    Transactions: '交易明细',
    orderTaking: '上架技能',
    onlyWithDraw:
      'Your earnings can only ly be withdrawn after a 30-day clearance.'
  },
  record: {
    contactus: '联络我们',
    ResolutionCenter: '客诉中心',
    Pendingclearance: '等待清算',
    sentemail: '确保你已发送邮件',
    Clearance: '清算',
    Hi: '您好',
    Sent: '我已经发邮件了',
    example: '范例',
    morehelp: '如果需要更多的帮助，请联络我们的官方邮箱。我们的邮箱是：',
    Game: '技能项目',
    SendEmail: '传送邮件',
    rejectedcancellation:
      'Since you rejected the cancellation request, please send us an Email, writing down the reason and uploading files by attachment to support your side of view. You will get our relply within 72 hours. Our Email address is',
    applyingcancel:
      'Since you are applying to cancel the order, please send us an Email, writing down the reason and uploading files by attachment to support your view. You will get our relply within 72 hours. Our Email address is',
    OrderID: '订单ID',
    Copy: '复制',
    Totalprice: '总付款金额',
    name: '暱称',
    Withdrawn: '提领',
    Availabletowithdraw: '可提领收入',
    amountofevery: '每次至少提领NT$3000，最高提领NT$10000',
    onlywithdrawonce: '提领后3-5个工作日到账',
    Yourearningscan: '满NT$3000才能提领',
    reviewthecase: '确保已经发送邮件了',
    stepinthease: '如果你已发送客诉邮件，nicee将会介入处理',
    canwithdraw:
      'Every transaction will go through a 7-day clearance before you can withdraw.'
  },
  login_title: '想玩游戏就约我',
  login_facebook: 'Facebook 登入',
  login_line: 'LINE 登入',
  login_google: 'Google 登入',
  login_other: '其他登入方式',
  login_phone: '手机号登入',
  login_agree: '登入即代表您同意nicee用户协议与隐私权条款',
  login_smscode: '获取认证码',
  login_now: '立即登入',
  home_index: '首页',
  home_feed: '动态',
  home_express_book: '急速约单',
  home_message: '讯息',
  home_my: '我的',
  home_recommended: '推荐',
  home_lol: '英雄联盟',
  home_duel: '传说对决',
  home_voice_chat: '语音交流',
  home_battle_canyon: '激斗峡谷',
  home_pubg: '绝地求生',
  home_small_alarm: '小闹钟',
  home_rankings: '排行版',
  home_top_players: '每日大神汇聚',
  home_voice_room: '语音房',
  home_input_nick: '请输入昵称/ID/游戏技能',
  home_cancel: '取消',
  home_skill_names: '各技能名称',
  home_pull_more: '下拉即可召唤更多陪陪',
  home_release_more: '释放即可召唤更多陪陪',
  home_loading: '加载中',
  gamelol: '英雄联盟',
  gamelol_order_king: '回单王',
  gamelol_rank_up: '上分必备',
  gamelol_filter: '筛选',
  gamelol_week_star: '联盟周星',
  gamelol_sort: '排序',
  gamelol_synthesize_sort: '综合排序',
  gamelol_new_sort: '新人优先',
  gamelol_high_sort: '高价优先',
  gamelol_low_sort: '低价优先',
  gamelol_gender: '性别',
  gamelol_female: '女生',
  gamelol_male: '男生',
  gamelol_label: '标签',
  gamelol_first_discount: '首单优惠',
  gamelol_buzzworthy: '夯口碑',
  gamelol_high_popular: '高人气',
  gamelol_high_new: '优质新人',
  gamelol_7_minute: '7分钟尝鲜',
  gamelol_expert_guiding: '大神带飞',
  gamelol_language_support: '语言陪伴',
  gamelol_tier: '段位',
  gamelol_elite: '菁英',
  gamelol_grand_master: '宗师',
  gamelol_master: '大师',
  gamelol_diamond: '钻石',
  gamelol_platinum: '白金',
  gamelol_expert_position: '擅长位置',
  gamelol_top_lang: '上单',
  gamelol_jungle: '打野',
  gamelol_mid_lang: '中单',
  gamelol_adc: 'ADC',
  gamelol_support: '辅助',
  gamelol_price: '价格',
  gamelol_clear_filter: '清空筛选',
  gamelol_complete: '完成',
  gameduel: '传说对决',
  gameduel_week_star: '传说周星',
  gameduel_tier: '段位',
  gameduel_eternal_legend: '永恒传说',
  gameduel_battlefield_legend: '战场传说',
  gameduel_starlight: '星耀',
  gameduel_diamond: '钻石',
  gameduel_platinum: '铂金',
  gamevoice: '语音交流',
  gamevoice_week_star: '音乐周星',
  gamevoice_tier: '段位',
  gamevoice_mom_voice: '妈音',
  gamevoice_queen_mom: '御妈音',
  gamevoice_queen_sister: '御姐音',
  gamevoice_queen_little: '少御音',
  gmaevoice_girl_little: '少女音',
  gmaevoice_luoli_little: '少萝音',
  gamevoice_luoli: '萝莉音',
  gamevoice_shou: '受音',
  gamevoice_uncle: '叔音',
  gamevoice_youth: '青年音',
  gamevoice_youth_shou: '青受音',
  gamevoice_youth_uncle: '青叔音',
  gamevoice_live: '实况主',
  gamebattle: '激斗峡谷',
  gamebattle_week_star: '综游周星',
  gamebattle_tier: '段位',
  gamebattle_elite: '菁英',
  gamebattle_grand_master: '宗师',
  gamebattle_master: '大师',
  gamebattle_diamond: '钻石',
  gamebattle_emerald: '翡翠',
  gamebattle_platinum: '白金',
  gamehero: '特战英豪',
  gamehero_tier: '段位',
  gamehero_soul: '辐能战魂',
  gamehero_myth: '神话',
  gamehero_diamond: '钻石',
  gamehero_platinum: '白金',
  gamehero_gold: '金牌',
  gamehero_silver: '银牌',
  gameapex: 'APEX',
  gameapex_tier: '段位',
  gameapex_hunter: 'APEX捕食者',
  gameapex_master: '大师',
  gameapex_diamond: '钻石',
  gameapex_platinum: '铂金',
  gamenaraka: '永劫无间',
  gamenaraka_tier: '段位',
  gamenaraka_abadi: '无间修罗',
  gamenaraka_bulan: '蚀月',
  gamenaraka_jatuh: '陨星',
  gamenaraka_platinum: '铂金',
  all_skills: '全部技能',
  normalskill: '常用技能',
  mbgame: '手机游戏',
  mbgame_duel: '传说对决',
  mbgame_battle: '激斗峡谷',
  mbgame_kart: '跑跑卡丁车Rush+',
  mbgame_live: '我要活下去',
  mbgame_pubg: '绝地求生M',
  mbgame_speed: '极速领域',
  mbgame_cn_pubg: '和平精英',
  mbgame_tomorrow: '明日之后',
  mbgame_knives_out: '荒野行动',
  mbgame_close_eye: '天黑请闭眼',
  mbgame_five: '第五人格',
  mbgame_auto_chess: '多多自走棋',
  mbgame_royale: '皇室战争',
  mbgame_bnb: '爆爆王M',
  mbgame_super_star: '明星三缺一',
  mbgame_dunk: '灌篮高手',
  mbgame_glory: '王者荣耀',
  mbgame_sky: 'sky光遇',
  mbgame_impact: '原神',
  mbgame_ro: 'RO新世代',
  mbgame_tom: '汤姆猫与杰利鼠：玩命追逐',
  mbgame_duty: '决胜时刻M',
  mbgame_palyer: '天天玩乐园',
  pcgame_lol: '英雄联盟',
  pcgame_battle: '特战英豪',
  pcgame_apex: 'APEX',
  pcgame_naraka: '永劫无间',
  pcgame_tft: '联盟战棋',
  pcgame_pubg: '绝地求生',
  pcgame_among: '太空狼人杀',
  pcgame_pubg_lite: '绝地求生Lite',
  pcgame_duty: '决胜时刻',
  pcgame_dota2: 'DOTA 2',
  pcgame_csgo: 'CSGO',
  pcgame_division2: '全境封锁2',
  pcgame_six_siege: '彩虹六号',
  pcgame_fortite: 'Fortnite',
  pcgame_overwatch: '斗阵特工',
  pcgame_flat: 'Human：Fall Flat',
  pcgame_world: '我的世界',
  pcgaame_monster_world: '魔物猎人：世界',
  pcgame_bnb: '爆爆王',
  pcgame_ring: '无限法则',
  pcgame_dead: '黎明死线',
  pcgame_exile: '流亡黯道',
  pcgame_war: '魔兽世界',
  pcgame_maplestory: '枫之谷',
  pcgame_rust: 'Rust',
  pcgame_monopoli: '大富翁',
  pcgame_overcooked: '煮过头',
  pcgame_hearthstone: '炉石战记',
  pcgame_gtav: 'GTA V',
  pcgame_warframe: 'Warframe',
  pcgame_knockout: '糖豆人',
  pcgame_super_animal: '超级动物大逃杀',
  pcgame_hunter_rise: '魔物猎人：崛起',
  pcgame_double: '双人成行',
  pcgame_diablo4: '暗黑破坏神4',
  pcgame_animal_crossing: '动物森友会',
  gamevoice_lover: '虚拟恋人',
  gamevoice_good: '好声音',
  gamevoice_no_sleep: '失眠陪伴',
  gamevoice_alarm: '小闹钟',
  gamevoice_film_online: '线上看电影',
  gamevoice_ask: '情感咨询',
  status: '动态',
  status_newest: '最近',
  status_recommend: '推荐',
  status_track: '追踪',
  status_just: '刚刚发布',
  status_comment: '马上留言，加入讨论吧',
  status_like: '喜欢',
  status_push_new: '发布动态',
  status_push: '发布',
  status_share: '分享一下今天的心情吧',
  status_input: '点击输入话题（限10字）',
  status_link: '点击设置关联技能',
  quickorder: '急速约单',
  quickorder_progress: '进行中的约单',
  quickorder_find: '正在寻找陪玩师',
  quickorder_report: '举报',
  quickorder_grab: 'x位陪玩师正在抢单',
  quickorder_grab_time: '抢单倒计时',
  quickorder_complete: '已完成的约单',
  quickorder_record: '仅保留最近10条约单记录',
  quickorder_want: '想找什么样的陪玩师呢？',
  quickorder_remark: '备注（选填）：例如“声音好听”等',
  myorder: '我的订单',
  myorder_want: '想找什么样的陪玩师呢？',
  myorder_lol: '英雄聪盟 模式不限牌位不限',
  myorder_sex: '性别不限',
  myorder_price: '单价不限',
  myorder_count: '数量（局）',
  order_complete: '确认订单',
  order_billing_mode: '计费模式',
  order_billing_mode_choose: '选择计费模式',
  order_normal_mode: '标准模式',
  order_by_count: '购买数量',
  order_discount: '优惠券',
  order_none: '暂无可用',
  order_fist_discount: '首单优惠',
  order_sum: '总计',
  order_total_pay: '总付款金额',
  message: '讯息',
  message_line: '绑定Line通知，讯息不漏接',
  message_system: '系统通知',
  message_house_keeper: '会员小管家',
  message_limit_activity: '限时活动',
  message_guard: '守护系统',
  message_none: '还没有讯息喔',
  chat_share: '分享',
  chat_block: '封锁',
  chat_report: '检举',
  chat_cancel: '取消',
  chat_hi: '哈喽你好吗？',
  chat_hope: '现在有空吗？（期待~',
  chat_ok: '好啊好啊！',
  chat_play: '来一场？',
  chat_next: '我们改天再约可以吗？',
  chat_some: '说些什么吧~',
  chat_send: '发送',
  report: '举报',
  report_reason: '选择举报理由',
  report_harassment: '发送虚假与有害信息骚扰用户',
  report_fake: '虚假个人资料',
  report_violation: '利用违规手段下单或接单',
  report_no_order: '陪玩师不接单',
  report_private_order: '私单检举（核实有奖）',
  report_other: '其他违规行为',
  report_picture: '请上传图片证据',
  report_5_pic: '必填，请上传最多5张清晰的关联材料',
  report_push: '提交',
  please_fill_in_review_content: '请填写评价内容',
  profile: '我的',
  profile_nicee: '金币',
  profile_diamond: '钻石',
  profile_candy: '糖果',
  profile_discount: '优惠券',
  profile_history: '查看历史订单',
  profile_orders: '我的订单',
  profile_gifts: '我的送礼',
  profile_see: '我看过',
  profile_fllow: '我的追踪',
  profile_dressup: '装扮',
  profile_invite: '邀请',
  profile_customer: '客服',
  profile_setting: '设置',
  profile_player: '我的（陪玩师面板）',
  profile_income: '收入',
  profile_exchange: '兑换/赠送',
  profile_skills: '技能',
  profile_feed: '动态',
  profile_client: '客户',
  profile_visit: '最近来访',
  profile_self_promotion: '自推广',
  profile_fans: '我的粉丝',
  profile_total_rating: '综合评分',
  profile_voice_room: '我的语音厅',
  material: '资料',
  material_edit: '编辑资料',
  material_photo: '我的相册',
  material_more_photo: '您可以上传9张图片向我们展示更多的了解你',
  material_lan_desc: '添加语言介绍',
  material_self_dec: '添加自我介绍',
  material_sex: '性别',
  material_birthday: '生日',
  material_address: '居住地',
  material_mars: '火星',
  material_guard: '守护者',
  material_null: '虚位以待',
  material_guard_amount: '当前设定初始守护金额为750',
  material_fisrt_guard: '首屏守护专位',
  material_special: '专属头像框',
  material_comment: '评论区昵称高亮',
  material_self_desc: '自我简介',
  material_guard_amount_set: '设定初始守护金额',
  material_cancel: '取消',
  material_save: '保存',
  material_content_null: '哇呜，这里好空~',
  material_self_profile: '个人信息',
  material_feed: '动态',
  maerial_feed_push: '发布动态',
  material_no_feed: '暂时还未发布任何动态喔~',
  level_desc: '等级说明',
  level_now: '当前等级',
  level_normal: '普通会员',
  level_month: '本月还需消费1，可提升至VIP1',
  level_benefits: '等级权益',
  member_exclusive_skin: '会员专属装扮',
  unlock_with_1688_spending: '月消费达1688解锁',
  exclusive_avatar_frame: '包含专属头像框、气泡框、入场横幅',
  monthly_10_coin_voucher: '每月1张10币折價券',
  no_minimum_spending_requirement: '无消费门槛限制，每月1号发放',
  upgrade_pending: '待升级',
  diamond_member: '钻石会员',
  sparkling_fireworks_avatar_frame: '“绮丽焰火”头像框',
  sparkling_stars_avatar_frame: '“璀璨星辰”头像框',
  dream_car_mount: '“梦幻跑车”坐骑',
  white_tiger_avatar_frame: '“白虎”头像框',
  extreme_car_mount: '“极限跑车”坐骑',
  black_gold_member: '黑金会员',
  qilin_avatar_frame: '“麒麟”头像框',
  white_tiger_mount: '“白虎”坐骑',
  crystal_shine_avatar_frame: '“晶耀”头像框',
  qilin_mount: '“麒麟”坐骑',
  exclusive_gift_pyramid: '专属礼物“金字塔”',
  legendary_member: '传奇会员',
  diamond_chest_available_this_month: '当月可领取钻石宝箱',
  current_defense_attempts: '当前拥有的保级次数',
  not_met_requirements: '未达标',
  cancel_10_quick_dates_per_month: '每月可主动取消10次急速约单',
  free_defense_privilege: '可享免费保级特权',
  specify_5_recommended_privileges: '可指定陪玩师上推荐特权5次',
  legend_avatar_frame: '“传奇”头像框',
  phoenix_mount: '“凤凰”坐骑',
  exclusive_gift_sky_city: '专属礼物“天空之城”',
  specify_1_app_cover_privilege: '可指定陪玩师上APP封面特权1次',
  king_legend_avatar_frame: '“王者传奇”头像框',
  dragon: '“神龙”坐骑',
  exclusive_gift_legend_throne: '专属礼物“传奇王座”',
  levelrule: '等级规则',
  levelrule_1: '有效期计算:从获得等级当期起，等级身份有效期至下个月月末。',
  levelrule_2:
    '举例：用户在2月5日获得等级VIP5，则VIP5过期时间为3月31日，4月1日重新结算等级。',
  levelrule_3:
    '等级升级: 用户通过消费 (订单，礼物消费) 可提升等级。常消费满足升级条件时会于当日获得新等级，新等级过期时间为升级当日至下个月末。',
  levelrule_4:
    '举例: 用户2月5日为VIP5，2月6日通过消费达到VIP6，则VIP6的有效期2.06-3.31。',
  levelrule_5:
    '保留等级:用户已有某等级，过期当月消费达到当前等级要求消费金额的70%，即可保留等级。',
  levelrule_6:
    '举例: 用户2月5日常前等级VIP11。假定11级封消费金额点100000，有效期至3.31,则续等需要4月1日前消费达到70000元，则下个月才可以进行等级保留。',
  levelrule_7:
    '等级降级:在用户等级过期当月，消费金额未达到对应等级的保留等级要求，则下一个结算月会降低等级，下个月没有完成当前对应等级要求的保留等级消费金额，则再降等级，以此推。',
  levelrule_8:
    '举例: 用户2月5日VIP5，若在结算月 (3月) 结束之前消费未达到VIP5与VIP4的要求的消费金额的70%，但达到了VIP3的要求消费金额的70%，则4月1号开始用户降级至VIP3。',
  retention_privilege: '保级特权',
  retention_privilege_1:
    '当期未消费足够保级金额，可以使用一次【保级特权】，继续保留会员等级到下个月末。届时下下月初会员等级是否保留需要根据结算月以及保级期间用户消费情况进行结算决定是否保留等级。【保级特权】: 每连续保持该等级会员三个月，可获得一次【保级特权】机会。',
  retention_privilege_2: '最高存有2次',
  retention_privilege_3: '不能连续两个月使用',
  retention_privilege_4:
    '如果掉级后重新回到SVIP1、SVIP2或者上个月使用了【保级特权】，则连续保持等级月数重新计算。',
  retention_privilege_5:
    '若用户在存有保级特权未使用的前提下晋升到更高等级的会员时保级次数会减少1次。',
  retention_privilege_6: '指定陪玩师上推荐特权',
  retention_privilege_7:
    '每月可推荐指定陪玩师上某时间段的推荐位，并配置为被推荐陪玩师配置专属标识 (单次推荐时长为6小时)',
  retention_privilege_8: '指定陪玩师上APP封面特权',
  retention_privilege_9:
    '每月可推荐陪玩师上官方定专属app封面1次，上推荐后所有用户打开app均会浏览到您所推荐陪玩师的专属封面。',
  recharge: '储值',
  recharge_1: '限时活动：狂欢大派送',
  recharge_2: '储值账号ID',
  recharge_3: '昵称',
  recharge_4: '选择金额',
  recharge_5: '选择付费方式',
  recharge_6: '信用卡(Visa/MasterCard/银联/AmEx)',
  recharge_7: '信用卡(Visa/MasterCard/JCB)',
  recharge_8: 'ATM转账',
  recharge_9: '商超代码',
  recharge_10: 'PayPal',
  recharge_11: '确认储值',
  discount: '优惠券',
  discount_1: '兑换优惠券',
  discount_2: '暂无优惠券',
  discount_3: '失效优惠券',
  discount_4: '确认兑换',
  discount_5: '请输入兑换码',
  discount_6: '点击输入兑换码',
  discount_7: '立即兑换',
  myorder_1: '订单教程',
  myorder_2: '全部订单',
  myorder_3: '进行中的订单',
  myorder_4: '历史订单',
  myorder_5: '暂无订单',
  orderdetail: '订单详情',
  orderdetail_1: '订单编号',
  orderdetail_2: '已取消',
  orderdetail_3: '礼物合计',
  orderdetail_4: '数量',
  orderdetail_5: '下单',
  orderdetail_6: '订单取消',
  gifts: '礼物',
  gifts_1: '收到的礼物',
  gifts_2: '您目前还没有收到礼物，再接再厉喔~',
  gifts_3: '送出的礼物',
  gifts_4: '您目前还没有送出礼物喔~',
  dressup_center: '头像框',
  dressup_center_1: '气泡框',
  dressup_center_2: '入场横幅',
  dressup_center_3: '坐骑',
  dressup_center_4: '繁花之恋',
  dressup_center_5: '心花绽放',
  dressup_center_6: '绿色情人节活动获得',
  dressup_center_7: '年度冠军',
  dressup_center_8: '年度亚军',
  dressup_center_9: '年度季军',
  dressup_center_10: '年度八强',
  dressup_center_11: '年度老板',
  dressup_center_12: '年度活动获取',
  dressup_center_13: '红茵球场',
  dressup_center_14: '蓝茵战场',
  dressup_center_15: '世界杯活动获取',
  dressup_center_16: '下单周榜',
  dressup_center_17: '下单榜周榜冠军获取',
  dressup_center_18: '甜爸',
  dressup_center_19: '甜宝',
  dressup_center_20: '父亲节活动获得',
  dressup_center_21: '遇龙舟',
  dressup_center_22: '好粽意',
  dressup_center_23: '端午节活动获得',
  dressup_center_24: '动人声',
  dressup_center_25: '待君倾',
  dressup_center_26: '以歌声入人心活动获得',
  dressup_center_27: '天使宠爱',
  dressup_center_28: '水晶宠爱',
  dressup_center_29: '宠爱积分赛活动获得',
  apply_for_settlement: '申请入驻',
  apply_for_settlement_1: 'nicee陪玩诚邀你成为我们的陪玩师',
  apply_for_settlement_2: '我们等待这样的你',
  apply_for_settlement_3: '风趣幽默，热爱聊天；热爱游戏，也热爱交友。',
  apply_for_settlement_4: '无论出于好奇或者职业，都希望把陪玩师做好。',
  apply_for_settlement_5:
    '如果你是这样的人，快快点击申请入驻，开启你的陪玩师之旅吧！',
  apply_for_settlement_6:
    '我已阅读并同意《nicee陪玩师行为守则》《服务协议与隐私条例》',
  apply_for_settlement_7: '立即申请',
  invite: '邀请',
  invite_1: '长达66天分佣奖励',
  invite_2: '邀请好友抽丰厚现金',
  invite_3: '分享',
  invite_4: '抽1次，剩余0次机会',
  invite_5: '10连抽，剩余0次机会',
  invite_6: '谢谢惠顾',
  invite_7: '我的邀请码',
  invite_8: '点击可复制',
  invite_9: '每邀请一个好友绑定邀请码则可获得1次抽奖机会',
  invite_10: '与您绑定的好友每储值1000nicee币可获得1次抽奖机会',
  invite_11: '当前已累积获得',
  invite_12: 'nicee币已自动充值到您的钱包（提取到您可提领收入）',
  invite_13: '我的活动记录',
  invite_14: '暂无记录，快去邀请好友注册吧',
  invite_15: '绑定好友邀请码',
  invite_16: '我是好友邀请注册，绑定好友邀请码帮好友获得抽奖机会',
  niceebot: 'nicee智慧机器人',
  niceebot_1:
    '我是nicee智慧机器人，请问您需要咨询什么问题呢？请描述您遇到的问题~',
  niceebot_2: '您是否遇到以下问题：',
  niceebot_3: '请问我的nicee ID是？',
  niceebot_4: '如何申请入驻陪玩师呢？',
  niceebot_5: '如何申请技能？需要提供什么材料？',
  niceebot_6: '如何制作声音卡？',
  niceebot_7: '怎么算完成订单呢？',
  niceebot_8: '订单遇到纠纷时该怎么办呢',
  niceebot_9: '请问可以去哪里抢单？',
  niceebot_10: '如何储值？',
  niceebot_11: '成功付款后30分钟余额没有变化，请问我该怎么办？',
  niceebot_12: '请问怎么将陪玩的收益转换成现金呢？',
  niceebot_13: '为什么我的头像不能通过审核？',
  niceebot_14:
    '我没有看到客服小助手的按钮或是官方发布的新功能，是不是系统坏了？',
  niceebot_15: '本照认证在哪申请呢？',
  niceebot_16: '请用一句话描述您的问题，尽可能简短喔^^',
  niceebot_17: '发送',
  niceebot_18: '温馨提示',
  niceebot_19: '您确认要结束本次对话吗？',
  niceebot_20: '确认',
  niceebot_21: '取消',
  official_customer_app_open_failed:
    '是否已安装 Nicee App？若尚未安装，可前往应用商店下载。',
  official_customer_go_to_store: '前往应用商店',
  leaderboard: '榜单',
  leaderboard_1: '红人榜',
  leaderboard_2: '新秀榜',
  leaderboard_3: '受宠榜',
  leaderboard_4: '下单榜',
  leaderboard_5: '送礼榜',
  leaderboard_6: '日榜',
  leaderboard_7: '周榜',
  leaderboard_8: '奖励及规则',
  leaderboard_9: '魅力值',
  luck_party: '幸运糖果Party',
  luck_party_1: '抽奖狂送钻石金币拿会员好礼',
  luck_party_2:
    '幸运糖果会员专属派对，抽钻石金币拿会员等级超多奖励，等你来拿！',
  luck_party_3: '活动时间',
  luck_party_4: '我的糖果',
  luck_party_5: '祝你好运',
  luck_party_6: '开始抽奖',
  luck_party_7: '每次消耗200糖果或消耗500钻',
  luck_party_8: '10大会员权益，等你来拿',
  luck_party_9: 'VIP1以上均可获得会员专属装扮',
  luck_party_10: 'VIP8以上均可额外解锁新头像框',
  luck_party_11: 'VIP5以上可领取免费折價券',
  luck_party_12: 'VIP10以上可领取免费钻石',
  luck_party_13: 'VIP9以上均有专属坐骑',
  luck_party_14: '开启特殊坐骑（梦幻跑车、极限跑车、神龙坐骑）体验，显尊贵身份',
  luck_party_15: 'VIP12以上均可享专属会员礼物',
  luck_party_16: '尊享专属礼物（天空之城、传奇王座）体验，点燃全场热情',
  luck_party_17: '查看10大会员权益',
  palyer_panel_1: '收入',
  palyer_panel_2: '兑换/赠送',
  palyer_panel_3: '赠送奖1000钻',
  palyer_panel_4: '技能',
  palyer_panel_5: '动态',
  palyer_panel_6: '客户',
  palyer_panel_7: '最近来访',
  palyer_panel_8: '自推广',
  palyer_panel_10: '我的订单',
  palyer_panel_11: '我的收礼',
  palyer_panel_12: '我的粉丝',
  palyer_panel_13: '综合评分',
  palyer_panel_14: '0分（高过0%）',
  palyer_panel_15: '我的语音厅',
  palyer_panel_16: '邀请',
  palyer_panel_17: '客服',
  palyer_panel_18: '设置',
  palyer_panel_19: '收入明细',
  palyer_panel_20: '可提领',
  palyer_panel_21: '结算中',
  palyer_panel_22: '总收入',
  palyer_panel_23: '收入中明细',
  palyer_panel_24: '收支明细',
  palyer_panel_25: '暂时没有产生记录哦',
  line_1: 'LINE通知设定',
  line_2: '当有人留言，有心订单时候，用LINE通知我',
  line_3: '请先看完下方的教学步骤，然后点击开启按钮',
  line_4: '点击下方右侧的开关按钮',
  line_5:
    '在新开网页中登入LINE，若您已安装LINEapp，下拉网页会出现“在LINE中打开”，点击即可快捷登入。',
  line_6: '登入成功后，点击第一个选项“通过1对1聊天接收LINE Notify的通知”',
  line_7: '点击页面最下方的“同意并联动”按钮',
  line_8: '启用LINE通知',
  skill_manage_1: '当前可接单',
  skill_manage_2: '添加新技能',
  skill_manage_3: '审核通过，请完善技能信息',
  skill_cancelled_not_applied: '未申请认证，去修改',
  myclient_1: '我的客户',
  myclient_2:
    '为了方便你更好的管理客户，我们特意为你准备了客户管理工具，快来看看吧！',
  myclient_3: '好久不见',
  myclient_4: '此处展示7-30天给您下单的客户，当老朋友出现时记得打个招呼喔~',
  myclient_5: '平台新人',
  myclient_6: '暂时没有新用户，去维护一下老朋友吧',
  recent_visitor_1: '最近来访',
  recent_visitor_2: '最近30天的访客',
  recent_visitor_3: '如何获得更多曝光',
  recent_visitor_4: '第1次访问',
  mypic_1: '本照认证',
  mypic_2: '超心动',
  mypic_3: '完成身份认证，享受3大特权',
  mypic_4: '本照徽章',
  mypic_5: '获得官方标示',
  mypic_6: '官方推荐',
  mypic_7: '提升曝光量',
  mypic_8: '订单提升',
  mypic_9: '吸引更多用户',
  service_1: '服务概况',
  service_2: '综合评分',
  service_3: '近60天数据',
  service_4: '全部技能',
  service_5: '回单率',
  service_6: '低于标准',
  service_7: '您的回单率低于平台平均水平，要努力喔~',
  service_8: '下单新用户数',
  service_9: '二次下单用户数',
  service_10: '人均回单金额',
  service_11: '回单金额',
  service_12: '1分钟回复率',
  service_13:
    '可接单状态下，您在1分钟内回复的数据偏低，这将影响到你的曝光和接单。',
  service_14: '有效好评率',
  service_15: '带有5字以上的五星好评数据偏低，记得请用户留下文字评价喔！',
  service_16: '有效好评数',
  service_17: '总好评数',
  myroom: '我的房间',
  who_1: '谁看过我',
  who_2: '最近30天的访客',
  who_3: '聊一聊',
  legal_rules_title: 'nicee陪玩师行为守则',
  legal_privacy_title: '服务协议与隐私条款',
  who_4:
    '*入驻nicee的陪玩师需为年满十八岁及以上之完全行为能力人，已阅读，了解并同意本服务协议之所有内容及其后之修改变更，方得使用本平台之服务。\n\n为营造健康的平台氛围，保障用户权益，请陪玩师遵守以下行为守则：\n\n壹.不得在个人信息、评论、技能描述、私信中发布违反法律法规信息\n\n包括但不限于危害安全、色情低俗、暴力恐怖、赌博、危害未成年等违法内容\n\n贰.不得在个人信息、评论、技能描述、私信中发布垃圾广告信息\n\n包括但不限于以推广、销售、盈利为目的，发布影响?户体验的内容\n\n叄.不得在个人信息、评论、技能描述、私信中发布盗版侵权信息\n\n包括但不限于未经本人同意，盗用他人肖像、姓名、作品的内容\n\n肆.不得在个人信息、评论、技能描述、私信中发布虚假信息\n\n包括但不限于诈骗，谣言等不实信息\n\n伍.不得在个人信息、评论、技能描述、私信中发布广告宣传信息\n\n宣传鼓励使用其他竞争平台，以任何形式包括但不限于头像、图片、暱称、标题、描述、评论等方式传播任何未经nicee平台授权的第三方个人/平台/广告信息/工具\n\n陆.不得脱离平台交易\n\n通过任何其他途径进行非平台订单交易\n\n柒.不得骚扰辱骂他人\n\n包括但不限于对平台用户发表谩骂，嘲讽，人身攻击等骚扰信息\n\n捌.不得伪造互动数据\n\n包括但不限于人工或机器作弊干预伪造数据，恶意注册多个帐号使用等作弊行为\n\n玖.不得损害平台利益，扰乱平台秩序\n\n以任何形式干扰平台管理，严重扰乱平台秩序，损害其他用户和平台合法权益的行为\n\n平台核实与处罚说明：\n\n1.平台会通过用户反馈，平台监控等多方面方式进行违规确认。\n\n2.为保障用户权益，请陪玩师保存自己的陪玩纪录以便核实。\n\n3.用户若不遵守以上行为守则，一旦发现违规行为，平台会视情节轻重程度采取相应的处罚措施，包括警告，限制部分功能使用权限，封禁帐号，严重行为将长期冻结帐号。\n\n本公司有权于任何时间修改或变更本陪玩师行为守则，并公告于本平台之网站（https://nicee.tw），请您随时注意该等修改或变更，恕不再另行个别通知。若您于任何修改或变更后继续使用本平台之服务，则视为您已阅读、了解并同意接受该等修改或变更。并同意完全遵守本陪玩师行为守则。\n\n我们致力于为广大用户营造安全健康的服务环境，平台的发展需要您的支持与配合，如在使用过程中有任何建议和反馈，欢迎联系我们的客服助手，祝您在nicee玩得愉快。',
  who_5:
    '本服务协议与隐私条款（以下简称「本协议」）载明您与「nicee」之间的权利义务关系，为保障您（以下或称「用户」）的权益，请于注册为「nicee」（以下简称「本平台」）用户前仔细阅读本条款。\n1、 名词定义\n（1） 「用户」：是指注册、登录、使用本平台任何服务的个人\n（2） 「服务」：系指本公司于本平台上提供用户透过电脑、智慧型装置或其他电子化设备分享、交流与线上游戏有关资讯之服务，以媒合平台用户进行【游戏辅导】相关即时互动。\n2、 认知与接受条款\n（1） 当您注册完成或开始使用本服务时，即表示您已阅读、了解并同意接受本服务协议之所有内容。如您不同意本服务协议的内容，或者您所属的国家或地域排除本服务协议内容之全部或部分时，您不应注册、登录本平台之网站，并应立即停止使用本平台相关服务。\n（2） 本公司有权于任何时间修改或变更本服务协议之内容，并公告于本平台之网站（https://www.nicee.tw/），请您随时注意该等修改或变更，恕不再另行个别通知。若您于任何修改或变更后继续使用本平台之服务，则视为您已阅读、了解并同意接受该等修改或变更。并同意完全遵守本协议及其他相关规范」。若您于任何修改或变更后继续使用本平台之服务，则视为您已阅读、了解并同意接受该等修改或变更。并同意完全遵守本协议及其他相关规范。\n（3） 若您并非十八岁以上之完全行为能力人，则应请您的父母或监护人阅读、了解并同意本服务协议之所有内容及其后之修改变更，方得使用本平台之服务。当您使用本服务时，即推定您的父母或监护人已阅读、了解并同意接受本服务协议之所有内容及其后之修改变更。\n（4） 为促进儿童及少年身心健全发展，并保障其相关权益，您了解本平台有涉及「游戏软体分级管理办法」分类标准下之「辅导十五岁级」游戏，故选择使用相应服务前，您应先了解各游戏官网所标明游戏之分级标志及适用年龄层。一旦使用特定服务，即推定您已符合相关法令对使用该游戏之年龄层要求。\n3、 用户注册与帐号保管\n（1） 您同意于注册用户时提供正确、最新的资料（详参第六条「隐私条款」），且仅能注册登录一个帐号，不可重覆注册登录。您所登录之资料若事后有所变更时，应随时于线上更新。如您提供的个人资料有任何不实或误导之嫌，本公司得随时终止您的用户资格及停止使用各项服务之权利。\n（2） 您须自行选择用户之帐号名称以及密码来建立帐号。若您的帐号名称涉嫌侵权，本公司得据此要求您更改帐号名称或迳为删除侵权之帐号。\n（3） 您同意一个帐号在同一时间只能有一人使用，且不会将自身帐号、密码转让、出租或出借予他人使用。\n（4） 完成注册后，用户将取得一个特定之密码及用户帐号，而维持密码及帐号之机密安全，是用户之责任。任何依照规定方法输入用户帐号及密码与登入资料一致时，无论是否由本人亲自输入，本平台将推定为用户本人所使用，故利用该密码及帐号所进行的一切行动，用户本人应负完全责任。\n（5） 若您发现自身帐号遭人非法使用或有任何异常破坏使用安全的情形时，请立即通知本公司以利停止该帐号之使用；但帐号及密码遭盗用、不当使用或其他无法辩识是否为本人亲自使用之情况时，对此所致之损害，除证明系因可归责于本公司之事由所致，本公司就接获您通知以前之帐号使用，将不负责处理。\n4、 支付方式和购买nicee金币\n（1） 您可利用本平台提供的支付方式储值「nicee余额」点数或购买其他服务，但浏览本平台所需之各项电脑设备须自行配备，包括但不限于「网际网路连线费用」、「电话费用」等电信相关费用。\n（2） 您明确了解并同意，若要在nicee服务中使用特定功能（例送礼、下单陪玩师等），您必须先透过nicee认可的购买渠道购买金币。如有违反前述规定，本公司有权停用或者删除您的账号，您将无法再透过您的账号取消您所有的资料，包括您账号中的金币与折扣券。\n（3） 您明确了解并同意，您购买金币是经过思考后的购买行为，除法律另有规定外，nicee没有任何责任义务为您提供任何理由的退款。若您购买金币后经应用商城取消订单，我们会将您已使用金币收回，而使用金币所伴随的各种效果（包括但不限于福利、等级、经验值、活动展示框、排行榜）也将一同收回。\n（4） 您理解并同意，您在nicee服务中所获得的金币（如：节日活动、榜单活动、相互赠礼），是无法兑换现金的。且所有使用者皆不得私下进行现金交易、买卖或出借账号。如有违反前述规定，本公司有权停用或删除您的账号。您将无法再透过您的账号使用服务。\n5、 用户守则与平台使用责任\n（1） 用户守则：您承诺绝不为任何非法目的或以任何非法方式使用本服务，并承诺遵守中华民国相关法规及国际惯例。若系中华民国以外之用户，并同意遵守所属国家或地域之法令。您同意并保证不得利用本平台之服务从事侵害他人权益或违法之行为，并遵守以下用户守则：\n1. 不得公布或传送任何诽谤、侮辱、具威胁性、攻击性、不雅、猥亵、不实、违反公共秩序或善良风俗或其他不法之文字、图片或任何形式的档案；不得侵害他人名誉权、肖像权、智慧财产权、商业秘密等，例如在未取得他人同意的情况下，分享可能会透露个人资讯或私人财产的内容，或未经许可在私人场所直播；\n2. 不得以图像、文字、影像及语音对未满十八岁之人表达「游戏软体分级管理办法」分类标准下之限制级内容，包含但不限于「具体性暗示」、「血腥、残暴或恐怖画面」、「粗鄙或仇恨性言语」、「使用毒品之画面或情节」、「描述抢劫、绑架、自伤、自杀等犯罪或不当行为」或「其他对未满十八岁人之行为或心理有不良影响之虞」等内容；\n3. 不得刊登、传送任何侵害他人智慧财产权（包含但不限于商标权、着作权、专利权、营业秘密等）、名誉权、隐私权或其他权益之资讯；\n4. 不得使用冒名、诈欺或其他虚伪不正之方式进行支付、储值，包含但不限于付款?之信?卡为伪卡或遭盗刷之情形；\n5. 不得将个人帐号转让、出租或出借予他人使用；\n6. 不得于未经授权之情形下，进入本公司之用户服务系统或网路、冒用他人之帐号；\n7. 不得传输、散布电脑病毒或其他足以干扰或破坏电脑系统、应用程式之资料或资讯；\n8. 不得从事未经本公司事前授权之商业行为或交易行为，包含但不限于「虚假交易」、「利用平台储值管道提出现金（如：刷卡套现）或转帐他人」、「以平台储值之款项交换非本平台之服务」等非正常使用目的之行为；\n9. 不得从事非法交易行为，或张贴虚假不实、引人犯罪之讯息；\n10. 不得贩卖枪砲、刀械、毒品、禁药、盗版软体或其他法令所禁止贩卖之物品；\n11. 不得对其他用户或第三人产生困扰、不悦或违反一般网路礼节致生反感之行为\n12. 不得提供赌博资讯或以其他方式发布引诱他人参与赌博的讯息；\n13. 不得干扰或中断提供本平台相关服务之伺服器、连结本平台之网路，或不遵守相关程序、政策或规则等；利用外挂程式、病毒程式、程式漏洞等其他违反公平合理之方式使用本平台之服务；\n14. 其他经本公司判断可能造成本平台损失或承担民事法律责任之不当使用行为，及任何涉嫌违法之行为（包含但不限于任何直接或间接之诈骗、洗钱、异常交易及犯罪行为）。\n（2） 用户之平台使用责任：\n1. 如经本公司判断您有违反前项各款守则或有违反之虞，本公司有权立即终止或变更您的帐号权限或采取适当法律行动，包含但不限于冻结帐号、停止提供平台服务、退款、追偿损失及拒收或保留您相关交易款项至釐清相关事证为止，并得因应有权管辖机关之裁判或命令而处置或移转您涉及不法行为之款项，本公司就前述行为不对用户或第三人负任何赔偿责任。\n2. 您必须为个人帐号内之行为负责，包括您所传送的任何文字、语音、图像、影音等内容，并承担因内容不当所引起之所有风险，若有任何违反法律规定之情事，包括但不限于侵害本公司或第三人之智慧财产权或其他权利、利益之行为，应自负相关法律责任。\n3. 如经本公司判断您有违反前项各款守则或有违反之虞，并致本公司受有损害、支出费用（包含但不限于行政作业成本、律师费、规费、任一储值管道之手续费、服务费）、政府裁罚或遭到任何第三人求偿，您应对本公司之前述损失负全额损害赔偿责任，若您向本公司证实前述损失不可归责于您，且经本公司核实无误，则该损失由本公司与您平均分担。\n4. 您通过本平台所传送的任何内容，均不代表本公司之观点或政策，本公司不会对此承担任何责任。\n6、 隐私条款\n本公司相当重视您的隐私权保护，特此向您说明本平台之隐私条款，以保障您的权益，请您详阅下列内容：\n（1） 隐私权条款适用范围：您使用本平台服务时本公司所蒐集到的个人识别资料。但并不适用于本平台以外的相关连结，也不适用于非本公司所委託或参与管理的人员。\n（2） 个人资料的蒐集目的与类别：\n1. 当您造访本平台或使用提供之服务时，因用户注册而请您提供必要的个人资料，并在该特定目的范围内处理及利用您的个人资料；非经您书面同意或另有约定，本公司不会将个人资料用于其他用途。您可以选择不提供前述之必要个人资料，但会造成您无法使用本平台之服务。\n2. 于一般浏览时，伺服器会自行记录相关行径，包括您使用连线设备的IP位址、使用时间、点选资料记录、浏览器类型、行动装置类型、位置资讯等，做为我们增进本平台服务的参考依据。您可以选择关闭伺服器之记录功能，但可能会造成您无法使用本平台之服务的情况。\n3. 上述资讯蒐集之类别，包含：C001辨识个人者、C011个人描述、C012身体描述、C013习惯、C014个性、C024其他社会关系、C035休闲活动及兴趣、C038职业、C051学校纪录、C091资料主体所取得之财货或服务、C092资料主体提供之财货或服务、C102约定或契约、C132未分类之资料。\n（3） 个人资料利用之对象及方式\n1. 为提供精确的服务，我们会将收集的数据内容进行去识别化之统计与分析。\n2. 上述资讯蒐集之特定目的，包含：040行销、063非公务机关依法定义务所进行个人资料之蒐集处理及利用、069契约、类似契约或其他法律关系管理之事务、081个人资料之合法交易业务、090消费者、客户管理与服务、091消费者保护、098商业与技术资讯、125传播行政与管理、135资（通）讯服务、142运动、竞技活动、148网路购物及其他电子商务服务、152广告或商业行为管理、153影视、音乐与媒体管理、157调查、统计与研究分析、181其他经营合于营业登记项目或组织章程所定之业务、182其他咨询与顾问服务。\n3. 个人资料利用之对象：本公司、本公司之关系企业、本公司之合作伙伴、相关委外之协力厂商（包含但不限于提供金流服务之厂商）及政府机关。\n4. 您对个人资料之权利：在不违反相关法律的情况下，我们确认该个人资料为您本人所有后，您可以联络我们行使下列权利：（1）查询、阅览、补充或更正您的个人资料；（2）停止蒐集、处理或利用您的个人资料；（3）删除您的个人资料；（4）制给您个人资料的复制本；或（5）停止寄发给您相关广告/行销活动。\n（4） 个人资料利用之期间及地区：\n1. 我们将在上述取得您个人资料目的之存续期间内或其他法令允许之期间内，处理、利用或国际传输您的个人资料，若您停止使用本平台并向我们终止本隐私条款之执行，本平台将停止蒐集、处理或利用您个人资料，并进行相关档案之删除作业。\n2. 本平台蒐集您个人资料之主机位置、相关网路伺服器主机所在地及本平台相关服务之行销地区。\n（5） 资料之保护：\n1. 本平台设有防火墙、防毒系统等相关的各项资讯安全设备及必要的安全防护措施与风险管理机制，您的个人资料采用严格的保护措施，只由经过授权的人员才能接触您的个人资料，如有违反保密义务者，将会受到相关的法律处分。\n2. 如因业务需要有必要委託其他单位提供服务时，本平台亦会严格要求其遵守保密义务，并且采取必要检查程序以确定其将确实遵守。\n3. 尽管我们尽力保护您的个人资料，然仍无法保证您的个人资料百分之百不会遭受第三人之非法拦截、传送或盗骇。前述事故发生时，我们将及时通报您，并对此启动相关应变措施及证据保存。\n（6） 您同意本公司，于下列情形发生时，得与第三人公开您的个人资讯：\n1. 经由您书面同意。\n2. 法律明文规定\n3. 为免除您生命、身体、自由或财产上之危险。\n4. 与公务机关或学术研究机构合作，基于公共利益为统计或学术研究而有必要，且资料经过提供者处理或蒐集者依其揭露方式无从识别特定之当事人。\n5. 当您在本平台的行为，违反服务条款或可能损害或妨碍平台其他用户之权益或导致任何人遭受损害时，本公司揭露您的个人资料是为了辨识、联络或采取法律行动所必要者。\n6. 有利于您的权益\n7. 本平台委託厂商协助蒐集、处理或利用您的个人资料时，将对委外厂商或个人善尽监督管理之责。\n8. 受司法、警察或其他有权机关基于法定程序之要求。\n9. 因您的行为违反法令、本条款或本公司相关规范时。\n（7） 隐私条款之修正：\n1. 本平台之隐私条款将因应需求随时进行修正，修正后的条款将于应用内告知用户，变更之内容遵循中华民国相关法令。如您不同意所变更之内容，得随时选择停止使用本平台，如您继续使用，即表示您同意变更之内容。\n2. 如果您对本平台的隐私条款有任何问题，或欲申请个人资料的查询、复制、补充、更正、阅览，或欲停止蒐集以及删除个人资料，请联络本平台之客服团队。\n7、 第三方网站连结与内容\n（1） 您了解本平台可能会显示广告影音并连结至第三方网站，或转载已注明来源之第三方网站之政令、新闻、讯息、活动等不同内容。\n（2） 惟第三方网站不属本服务协议得控制及负责范围之内，其内容之正确真伪，您宜自行判断之，本公司对其正确真伪不负任何责任。\n（3） 您同意本公司无须为您连结至前述第三方网站所生之任何损害，负损害赔偿之责任。\n8、 用户行为与授权\n（1） 您所上载、输入或提供予本平台之任何资料（包括您的智慧财产权），即表示您已同意授权本公司可以基于行销目的、统计、业务改良、推广本服务之目的，进行使用、修改、发行、散布、重制或公开展示该等资料，并得在此范围内将前述权利转授权他人。\n（2） 您并保证本平台于服务中使用、修改、发行、散布、重制、公开展示或转授权该资料，不致侵害任何第三人之相关权利，否则应对本公司之损害负赔偿责任。\n9、 智慧财产权\n（1） 除本平台中涉及的「游戏」之智慧财产权由原游戏公司享有，及第三方投放广告所涉之智慧财产权由该广告商享有外，本平台所使用之程式、软体及网站内容，包括但不限于：资讯、资料、图片、画面安排、服务名称、网站架构、网页设计及用户内容等，包括但不限于专利权、着作权、商标权、营业秘密等智慧财产权，均为本公司所有。任何人不得迳自修改、重制、散布、发行、公开发表、进行还原工程或反向组译。若您欲引用或转载前述资料，均须事前取得本公司之书面同意。\n（2） 本平台在相关服务中所使用之图形、文字或其组成，以及其他「nicee」标志及产品、服务名称（统称「nicee之标识」），其着作权或商标权归本公司所有，未经本公司事前书面同意，任何人不得以任何方式使用「nicee之标识」。\n10、 服务之中断或故障\n（1） 本平台所提供之服务可能会出现中断或故障等现象，或许将造成您使用上的不便、资料丧失、错误等情形。您于使用本服务时宜自行采取防护措施。\n（2） 本会对于您因使用（或无法使用）本服务而造成的损害，不负任何赔偿责任。于发生下列情形之一时，本公司有权停止或中断提供服务。因此而产生之困扰、不便或损害，本公司对任何会员或第三人均不负任何责任：\n1. 对本平台之相关软硬体设备与电子通信设备进行必要之保养及施工时。\n2. 发生突发性之软硬体设备与电子通信设备故障时。\n3. 在紧急情况下为维护其他会员或第三人之财产及人身安全时。\n4. 任何因第三人可能通过本平台及其服务传输的任何软体错误、病毒、木马或类似性质的程式而致本公司之平台无法提供全部或一部服务时。\n5. 因天灾等不可抗力之因素致使本公司无法提供本平台相关服务时。\n11、 免责声明\n（1） 您明确了解本公司按照现有技术和条件所能达到的现状提供本平台之相关服务，惟无法随时预见法律、技术以及其他风险。若出现前述风险时，本公司将努力在第一时间及时修复，但因此对于本平台及其服务所生之任何资料的错误、迟延或遗漏，本公司均不负担任何法律责任。\n（2） 本公司对本平台之各项服务不提供任何明示或默示之担保，并保留因业务发展而得单方调整服务内容之权限，用户因服务内容调整所生之损失，本公司均不负担任何法律责任。\n（3） 此外，您因违反本协议所生之任何损害及损失，均由您自负其责，本公司、不负担任何损害赔偿责任。\n12、 通知：\n（1） 您同意本公司得于任何时间点，不经通知随时修改、暂时或永久停止继续提供本服务（或其任一部分）的权利。\n（2） 本平台之通知方式包括但不限于：张贴于本服务网页、电子邮件，或其他现在或未来合理之方式通知您，包括本服务协议之变更。但若您违反本服务协议，以未经授权的方式存取本服务，或于注册时所提供之资料不正确或未更新，您将不会收到前述通知\n（3） 您同意当您于本平台登录帐号并使用相关服务时，本平台所为之任何及所有给您的通知均视为送达。\n13、 其他：\n（1） 本服务协议之解释与适用，以及与本服务协议有关之争议或纠纷，应依照中华民国法律予以处理，并以台湾台北地方法院为第一审管辖法院。\n（2） 本协议部分无效时，不影响其他协议之效力。\n（3） 本协议之标题仅供方便而设，不具任何法律或契约效果。',
  this_booster_has_taken_this_skill_offline_quickly_contact_them_to_put_it_online:
    '该陪玩师将此技能下架了喔，快联络{msg}上架此技能吧！',
  price_range_minutes7: '价格必须在30-40之间喔',
  price_range_limit: '价格必须在{priceLeft}-{priceRight}之间喔',
  price_range_invalid: '请输入有效价格',
  custom_price: '自定义价格',
  custom_price_placeholder: '输入价格',
  new_user_auto_greeting: '自动招呼新客户',
  new_user_auto_greeting_tip: '新用户注册后，系统会自动用此内容开启1v1聊天',
  new_user_auto_greeting_voice: '语音消息',
  new_user_auto_greeting_limit: '可被推送需综合评分1000以上，且当时在线并为「现在可接单」状态',
  enable_new_user_auto_greeting: '启用自动招呼新客户',
  new_user_auto_greeting_empty: '文字或语音至少填写一项喔',
  jkoPay: {
    name: '街口支付', retry: '重新查询付款结果', resultPending: '付款结果待确认',
    success: '付款成功', unconfirmed: '付款尚未确认', queryFailed: '暂时无法查询付款结果',
    processing: '付款确认中', credited: '{asset}已成功到账。',
    genericPending: '您的充值请求已提交，我们正在向银行确认交易结果。请稍候 1～5 分钟。',
    unconfirmedDescription: '尚未查到街口付款成功结果，您可以稍后重新查询，请勿重复付款。',
    queryFailedDescription: '系统暂时无法查询街口付款结果，请稍后重新查询，请勿重复付款。',
    processingDescription: '正在向街口支付确认付款结果，请勿重复付款。',
    nicee: 'Nicee 币', diamond: '钻石'
  }
};
export default cn;
